import React, { useRef, useState, useEffect } from "react";
import {
    GraphComponentContainer,
    ButtonHeader,
    RemoveWLButton,
    CloseComponentButton,
    StyledIconSlashButton,
    StyledIconButton,
    InputItemContainer,
    RegularText,
    CheckboxContainer,
    StyledCheckbox,
    FormH1,
    CardContainer,
    LeftSection,
    StockHeader,
    StockSymbol,
    StockName,
    PriceContainer,
    CurrentPrice,
    PriceChange,
    DataGrid,
    DataRow,
    DataLabel,
    DataValue,
    RightSection,
    SectionTitle,
    ActionToggleGroup,
    ToggleButton,
    InputGroup,
    InputLabel,
    StyledInput,
    SubmitButton,
    RightHeaderContainer,
    HeaderWrapper,
    ToggleWrapper,
    Option,
    Divider
} from "./PortfolioChartElements";
import TradesList from "../TradesForms";

const PortfolioChartStation = ({ handleClearCurrentStock, currentStock, stock_data, token, selectedAccount }) => {

    const [controlsDropdown, setControlsDropdown] = useState(false);
    const [maxInvestment, setMaxInvestment] = useState('');
    const [open, setOpen] = useState(null);
    const [close, setClose] = useState(null);
    const [high, setHigh] = useState(null);
    const [low, setLow] = useState(null);
    const [volume, setVolume] = useState(null);
    const [ind, setInd] = useState("D");

    useEffect(() => {
        if (stock_data) {
            setOpen(stock_data.open);
            setClose(stock_data.close);
            setHigh(stock_data.high);
            setLow(stock_data.low);
            setVolume(stock_data.volume);
        }
    }, [stock_data]);


    const handleDropdown = (e) => {
        e.preventDefault();
        setControlsDropdown(!controlsDropdown)
    }

    const options = ['D', 'M', '3M', 'YTD'];

    const handleSetTimeframe = (e, opt) => {
        e.preventDefault();
        setInd(opt)
    }

    return (
        <GraphComponentContainer>
            {open ?
                <CardContainer>
                    <LeftSection>
                        <HeaderWrapper>
                            <StockHeader>
                                <StockSymbol>{currentStock.ticker}</StockSymbol>
                                <StockName>{stock_data.title}</StockName>
                            </StockHeader>
                            <ToggleWrapper>
                                {options.map((opt, index) => (
                                    <>
                                        <Option isActive={ind === opt} onClick={(e) => handleSetTimeframe(e, opt)}> {opt}</Option>
                                        {index < options.length - 1 && <Divider>|</Divider>}
                                    </>
                                ))}
                            </ToggleWrapper>
                        </HeaderWrapper>

                        <PriceContainer>
                            <CurrentPrice>${close["D"]?.toFixed(2)}</CurrentPrice>
                            <PriceChange isPositive={open ? open[ind] < close["D"] : true}>
                                {open[ind] < close["D"] ? '+' : '-'}${Math.abs(close["D"] - open[ind]).toFixed(2)} ({Math.abs(((close["D"] - open[ind]) / open[ind]) * 100).toFixed(2)}%)
                            </PriceChange>
                        </PriceContainer>

                        <DataGrid>
                            <DataRow>
                                <DataLabel>Open</DataLabel>
                                <DataValue>${open[ind]?.toFixed(2)}</DataValue>
                            </DataRow>
                            <DataRow>
                                <DataLabel>High</DataLabel>
                                <DataValue>${high[ind]?.toFixed(2)}</DataValue>
                            </DataRow>
                            <DataRow>
                                <DataLabel>Volume</DataLabel>
                                <DataValue>{(volume[ind] / 1000000)?.toFixed(1)}M</DataValue>
                            </DataRow>
                            <DataRow>
                                <DataLabel>Low</DataLabel>
                                <DataValue>${low[ind]?.toFixed(2)}</DataValue>
                            </DataRow>
                        </DataGrid>
                    </LeftSection>
                    <RightSection>
                        <form style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                            <div>

                                <RightHeaderContainer>
                                    <SectionTitle>Ownership Details</SectionTitle>
                                    <ButtonHeader>
                                        <CloseComponentButton onClick={(e) => handleClearCurrentStock(e)} />
                                    </ButtonHeader>
                                </RightHeaderContainer>
                                <DataGrid>
                                    <DataRow>
                                        <DataLabel>Shares</DataLabel>
                                        <DataValue>{currentStock.shares}</DataValue>
                                    </DataRow>
                                    <DataRow>
                                        <DataLabel>Average Cost Basis</DataLabel>
                                        <DataValue>${currentStock?.cost.toFixed(2)}</DataValue>
                                    </DataRow>
                                    <DataRow>
                                        <DataLabel>Current Market Value</DataLabel>
                                        <DataValue>${(close["D"] * currentStock.shares).toFixed(2)}</DataValue>
                                    </DataRow>
                                    <DataRow>
                                        <DataLabel>Gain/(Loss)</DataLabel>
                                        <DataValue>
                                            {(() => {
                                                const profitOrLoss = (close["D"] * currentStock.shares) - (currentStock?.cost * currentStock.shares);
                                                const isPositive = profitOrLoss >= 0;
                                                const formattedValue = Math.abs(profitOrLoss).toFixed(2);

                                                return isPositive ? `$${formattedValue}` : `($${formattedValue})`;
                                            })()}
                                        </DataValue>
                                    </DataRow>
                                </DataGrid>
                            </div>
                        </form>
                    </RightSection>
                </CardContainer>

                : <></>}
            <TradesList ticker={currentStock.ticker} token={token} trades={['some']} selectedAccount={selectedAccount} />
        </GraphComponentContainer >
    );
};

export default PortfolioChartStation;